<script lang="ts">
    import { onDestroy } from 'svelte'

    import Icon from '@iconify/svelte'
    import { orderBy } from 'lodash-es'
    import { filter } from 'rxjs/operators'

    import { gettext as _, resolve } from 'hydria/services/gettext'
    import { simpleFetch, type SimpleFetchResult } from 'hydria/services/session'
    import { sanchor, spath } from 'hydria/svelte_helpers'
    import { DateTime, toLuxon } from 'hydria/utils/time'

    import { stream, type StreamEvent } from 'wdom/services/stream'
    import type { Task } from 'wdom/types/task'

    import Date from 'hydria/components/Date.svelte'
    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    let loading = $state(true)

    // let taskIndex: { [key: string]: Task } = $state({})
    let tasks: Task[] = $state([])

    function importTasks(inTasks: Task[]) {
        const lTaskIndex: { [key: string]: any } = []
        let done: any[] = []
        let running: any[] = []

        for (const task of inTasks) {
            if (!(task.ctime instanceof DateTime)) {
                task.ctime = toLuxon(task.ctime)
                if (task.etime != null) task.etime = toLuxon(task.etime)
            }

            if (task.state == 'RUNNING' || task.state == 'READY') {
                running.push(task)
            } else {
                done.push(task)
            }
        }
        done = orderBy(done, [(task) => (task.etime != null ? task.etime : task.ctime)], ['desc'])
        running = orderBy(running, [(task) => (task.etime != null ? task.etime : task.ctime)], ['desc'])

        // const maxDone = Math.max(7 - running.length, 5)
        // if (done.length > maxDone) {
        //     done.splice(maxDone - done.length, done.length - maxDone)
        // }
        tasks = running.concat(done)
    }

    // rxun(() => {
    //     let done: Task[] = []
    //     let running: Task[] = []

    //     for (const task of Object.values(taskIndex)) {
    //         if (task.state == 'RUNNING' || task.state == 'READY') {
    //             running.push(task)
    //         } else {
    //             done.push(task)
    //         }
    //     }
    //     done = orderBy(done, [(task) => (task.etime != null ? task.etime : task.ctime)], ['desc'])
    //     running = orderBy(running, [(task) => (task.etime != null ? task.etime : task.ctime)], ['desc'])

    //     const maxDone = Math.max(7 - running.length, 5)
    //     if (done.length > maxDone) {
    //         done.splice(maxDone - done.length, done.length - maxDone)
    //     }
    //     tasks = running.concat(done)
    //     taskIndex = {}
    //     for (const task of tasks) {
    //         taskIndex[task.id] = task
    //     }
    // });

    simpleFetch('GET', '/json/task/1/', { data: JSON.stringify({ state: 'RUNNING' }, null, 0) })
        .then((r: SimpleFetchResult) => {
            importTasks(r.data.items)
            loading = false
        })
        .catch((e) => {
            console.error('Error loading tasks for the dashboard:', e)
            loading = false
        })

    // Listen to the stream for task events and update the tasks
    unsubs.push(
        stream.pipe(filter((e) => (e as StreamEvent).event == 'task')).subscribe({
            next: (e) => {
                const task = { ...(e as StreamEvent).data }

                importTasks([...tasks.filter((t) => t.id != task.id), task])
            },
        }),
    )
</script>

<style>
    .list-group-item {
        border-width: 0 0 1px 0;
        border-radius: 0 !important;
    }
</style>

<div class="card">
    <div class="card-title text-primary">{$_('Tâches en cours')}</div>
    {#if loading}
        <div class="card-body">
            <LoadingPattern pattern={['x', 'x']} />
        </div>
    {:else if !tasks.length}
        <div class="card-body">
            <p>{$_('Aucune tâche en cours.')}</p>
        </div>
    {:else}
        <div class="card-body">
            <ul class="list-group">
                {#each tasks as task (task.id)}
                    <li class="list-group-item" data-task-id={task.id}>
                        <div class:text-success={task.state == 'SUCCESS'} class:text-danger={task.state == 'FAILED'} class:text-info={task.state == 'RUNNING' || task.state == 'READY'}>
                            {#if task.state == 'SUCCESS'}
                                <Icon inline icon="fa:check" />
                            {:else if task.state == 'FAILED'}
                                <Icon inline icon="fa:exclamation-triangle" />
                            {:else}
                                <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                            {/if}
                            <a class:text-success={task.state == 'SUCCESS'} class:text-danger={task.state == 'FAILED'} class:text-info={task.state == 'RUNNING' || task.state == 'READY'} use:sanchor href={spath(`/task/${task.id}`)}>{$resolve(task.name, task.name_args)}</a>
                        </div>
                        <div class="time-recent-activity">
                            <time><small class="text-muted"><Icon inline icon="fa:clock-o" /> <Date value={task.etime != null ? task.etime : task.ctime} format="h-table-s" /></small></time>
                        </div>
                    </li>
                {/each}
            </ul>
        </div>
    {/if}
</div>
